import { Link, useHistory } from "react-router-dom";
import { Routes } from "../../../AppRoutes";
import { Box, Table } from "../../../components";
import { getListIdByFieldsContext, getProcessPathByListId } from "../../procedure/util";
import { useLandingStatistic } from "../../procedure/dashboard/hooks/use-landing-statistic";
import { DateHelper } from "../../../helper";
import { ColumnsType } from "antd/lib/table";
import { requestStatus } from "../../../constants";
import { approveProcess } from "../../procedure/human-organization/absence-letter/constants";
import { useStep } from "../../procedure/human-organization/absence-letter/hooks";

type MyRequestType = {
  renderCreatedDate: (date: string, isPin: boolean, isAttachment: boolean, data: any) => void;
};

const MyRequestTable = (props: MyRequestType) => {
  const { renderCreatedDate } = props;
  const { sortedMyRequests, isPin, isHaveAttachment } = useLandingStatistic();

  const history = useHistory();
  const { checkRequestStatus } = useStep();

  const columns: ColumnsType<any> = [
    {
      title: "Mã YC",
      dataIndex: "id",
      key: "id",
      align: "center" as const,
      width: 120,
      render: (value: any, record: any) => renderCreatedDate(record.id, record.isPin, record.isAttachment, record),

    },
    {
      title: "Nội dung yêu cầu",
      dataIndex: "Title",
      key: "Title",
    },
    {
      title: "Ngày tạo ",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render: (value: any, record: any) => DateHelper.formatDateToString(record.createdDateTime),
      width: 150,
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      align: "center" as const,
      width: 120,
      render: (text: string, record: any) => {
        if (record.eRequestStatus === requestStatus.completed) {
          return <div className="flag success">Đã hoàn tất</div>;
        }
        if (record.eRequestStatus === requestStatus.rejected) {
          return <div className="flag danger">Đã từ chối</div>;
        }
        if (checkRequestStatus(approveProcess, record) === requestStatus.approved) {
          return <div className="flag success">Đã duyệt</div>;
        }
        return <div className="flag warning">Đang đợi duyệt</div>;
      },
    },
  ];

  const dataSource = sortedMyRequests.map((item: any, index: number) => {
    const { eContent, ...restFields } = item.fields;
    return {
      index: index + 1,
      eTag: item.eTag,
      id: item.id,
      ...restFields,
      "fields@odata.context": item["fields@odata.context"],
      createdDateTime: item.createdDateTime,
      isPin: isPin(item),
      isAttachment: isHaveAttachment(item),
    };
  });

  return (
    <Box
      title="Yêu cầu của tôi"
      className="mb-0"
      titleRight={
        <Link to={{ pathname: Routes.details.path, search: "requests=my" }} className="px-4 pt-2">
          Chi tiết &gt;&gt;&gt;
        </Link>
      }
    >
      <Table
        rowKey="eTag"
        // loading={isLoading}
        columns={columns}
        dataSource={dataSource}
        onRow={(record) => ({
          onClick: () =>
            history.push(
              getProcessPathByListId(getListIdByFieldsContext(record["fields@odata.context"])).replace(":id", record.id)
            ),
          style: { cursor: "pointer" },
        })}
      />
    </Box>
  );
};

export default MyRequestTable;
